import { API_URL } from "../../../Config/api";
import styled from "styled-components";
import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Backoffice/Sidebar";
import Title from "../../../Components/Backoffice/Title";
import Header from "../../../Components/Backoffice/Header";
import Footer from "../../../Components/Backoffice/Footer";
import Card from "../../../Components/Backoffice/Card";
import {
  Col,
  Row,
  Button,
  notification,
  Form,
  Input,
  Dropdown,
  message,
  Space,
  Tooltip,
  Radio,
  Checkbox,
  Modal,
  Message,
  Table,
  Upload,
  Select,
  Pagination,
  Divider,
} from "antd";

import { ReactComponent as IconSearch } from "../../../Assets/Images/Backoffice/Search.svg";
import { ReactComponent as IconOptions } from "../../../Assets/Images/Backoffice/Options.svg";
import ExportButton from "../../../Components/Backoffice/ExportButton";
import Search from "antd/es/input/Search";

const Wrapper = styled.main`
  background-color: #e8e9f3;
  display: grid;
  grid-template-columns: var(--sidebar-width, 7.083vw) 1fr;
  transition: grid-template-columns 0.3s ease;
  min-height: 100vh;

  .btn-descricao {
    margin-top: 10px;
    height: 45px !important;
    padding: 0 15px;
    font-weight: bold;
  }

  .export-logs .ant-btn,
  .export-logs .ant-space-item,
  .export-logs.ant-btn-primary.cta {
    min-height: 45px !important;
  }

  .ant-space-item {
    height: -webkit-fill-available !important;
  }

  .div-banner-img {
    height: 150px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    background-size: cover;
    background-position: center center;
  }

  #newClube {
    background: #e8e9f3 0% 0% no-repeat padding-box;
    border: 4px dashed #d6d7e2;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100%;

    .cta {
      border-radius: 12px;
      height: 46px;
    }
  }

  .icon-edit {
    cursor: pointer;
  }

  .cta.publish {
    margin-right: 0;

    svg path {
      fill: #fff;
    }
  }

  @media (max-width: 992px) {
  }
`;

const TableFooter = styled.div`
  bottom: 16px;
  left: 0;
  position: absolute;
`;

const ContentHeader = styled.div`
  align-items: center;
  display: grid;
  gap: 22px;
  grid-template-columns: 1fr auto;
`;

const Content = styled.div`
  padding: 1.771vw;
`;

const CardHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  // gap: 60px;
  grid-template-columns: 1fr auto auto;
`;

const CardContent = styled.div`
  margin: 0;
  position: relative;

  input,
  button {
    min-height: 46px;
  }

  table th {
    color: #809fb8 !important;
  }

  table td {
    color: #494d7d;
  }

  .ant-checkbox-checked span.ant-checkbox-inner,
  .ant-checkbox-checked:hover span.ant-checkbox-inner {
    background-color: #1ad598 !important;
    border-color: #1ad598 !important;
  }

  .ant-checkbox:hover span.ant-checkbox-inner {
    border-color: #1ad598 !important;
  }

  li.ant-pagination-item {
    border: 1px solid #d9e1e7cc;
  }

  li.ant-pagination-item.ant-pagination-item-active {
    background-color: #8688a8;
    border-color: #8688a8;
    color: #ffffff;
  }
`;

export default function DashboardLogs() {
  document.title = "SPAP - Logs";
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [dataToShow, setDataToShow] = useState([]);
  const [current, setCurrent] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const [tablePagination, setTablePagination] = useState(25);
  const selectHandleChange = (value) => {
    setTablePagination(value);
  };

  const tableOnChange = () => {};

  const getLogsUserName = (logs, users) => {
    logs?.map((log) => {
      let userLog = log.user_id;
      users.map((user) => {
        if (user.id == userLog) {
          let primeiroNome = user.name;
          let apelido = user.apelido?.length > 0 ? user.apelido : "";
          let nomeAMostrar =
            primeiroNome + " " + apelido + " (" + user.id + ")";
          log.user = nomeAMostrar;
        }
      });

      let dataCriacao = new Date(log.created_at);
      let dia = dataCriacao.toLocaleDateString();
      let hora = dataCriacao.getHours();
      let minutos = dataCriacao.getMinutes();

      log.data = dia + " " + hora + "h" + minutos + "m";
    });

    logs?.sort((a, b) => b.id - a.id);

    let data = [];

    for (let i = 0; i < logs?.length; i++) {
      data.push({
        key: i,
        descricao: logs[i].descricao,
        user: <b>{logs[i].user}</b>,
        userName: logs[i].user,
        created: logs[i].data,
      });
    }

    return data;
  };

  useEffect(() => {
    fetch(`${API_URL}/all-logs`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar logs");
        }
        return response.json();
      })
      .then((data) => {
        if (data?.length === 0) {
          console.log("nenhum evento");
        }
        setUsers(data.users);
        setLogs(data.logs);
        setDataToShow(() => getLogsUserName(data.logs, data.users));
      })
      .catch((error) => console.error(error));
  }, []);

  const handleSearch = (value) => {
    setCurrent(1);
    setSearchTerm(value.toLowerCase());
  };

  const filteredLogs = dataToShow.filter(
    (log) =>
      log?.userName.toLowerCase().includes(searchTerm) ||
      log.descricao.toLowerCase().includes(searchTerm)
  );

  const startIndex = (current - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentData = filteredLogs.slice(startIndex, endIndex);

  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
      sorter: false,
    },
    {
      title: "Utilizador",
      dataIndex: "user",
      sorter: false,
    },
    ,
    {
      title: "Data",
      dataIndex: "created",
      sorter: false,
    },
    // {
    //   title: (<Dropdown menu={menuProps}>
    //   <Button>
    //     <Space>
    //       Ações
    //       <DownOutlined />
    //     </Space>
    //   </Button>
    // </Dropdown>),
    //   dataIndex: 'action'
    // }
  ];

  return (
    <Wrapper>
      <div>
        <Sidebar />
      </div>
      <Content>
        <Header />

        <ContentHeader className="mb-10">
          <Title>Logs</Title>
          <Col align="right" span={24}>
            <Space size={28} className="export-logs">
              <Search
                className="back-input"
                style={{ width: "500px" }}
                placeholder="Procurar..."
                onSearch={(e) => handleSearch(e.target.value)}
                onChange={(e) => handleSearch(e.target.value)}
                enterButton
              />
              <ExportButton
                data={dataToShow}
                columns={columns}
                fileName="logs"
              />
            </Space>
          </Col>
        </ContentHeader>
        <Card className="table-section">
          <CardContent>
            <Table
              columns={columns}
              dataSource={filteredLogs}
              onChange={() => tableOnChange}
              pagination={{
                pageSize: pageSize,
                showSizeChanger: true,
                locale: { items_per_page: " / página" },
                pageSizeOptions: ["10", "25", "50"],
                onShowSizeChange: (_, newSize) => setPageSize(newSize),
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
              }}
            />
            <TableFooter>
              <Select
                defaultValue={tablePagination}
                style={{
                  width: 120,
                }}
                onChange={selectHandleChange}
                options={[
                  {
                    value: "5",
                    label: "5",
                  },
                  {
                    value: "10",
                    label: "10",
                  },
                  {
                    value: "20",
                    label: "20",
                  },
                  {
                    value: "50",
                    label: "50",
                  },
                ]}
              />
            </TableFooter>
          </CardContent>
        </Card>
        <Footer />
      </Content>
    </Wrapper>
  );
}
